import React from "react";
import Navbar from "./Navbar.jsx";
import TitleSection from "./TitleSection.jsx";
import VisCard from './VisCard.jsx';
import Services from "./Services.jsx";
import Contact from "./Contact.jsx";
import BookAppointment from "./BookAppointment.jsx";
export default function Home()
{
return (
    <div>
    <Navbar/>
    <TitleSection />
    <VisCard/>
    <Services/>
    <BookAppointment/>
    <Contact/>
  </div>
  );
}